import React, {useEffect, useState} from 'react';
import {inject} from 'mobx-react';
import Moment from 'moment';
import {DialogContent, withStyles} from '@material-ui/core';

import TabelaAgendamentosDisponiveis from './TabelaAgendamentosDisponiveis';
import Header from './Header';

import Dialog from '../../../Dialog/Dialog';
import ButtonPrimary from '../../../Button/ButtonPrimary';
import {getUnidadeLogado} from '../../../../services/UsuarioService'
import {observer} from 'mobx-react-lite';

const TransferirAgendamentos = observer((props) => {
  const {
    open,
    classes,
    profissionalSaudeStore,
    atendimentoStore,
    onConfirm,
    onCancel
  } = props;

  const [filtro, setFiltro] = useState({
    profissionalSaudeId: null,
    dataInicio: Moment(),
    dataFim: null,
    periodos: { label: 'Todos', value: { horaInicio: '00:00', horaFim: '23:59' } },
  })
  const [profissionaisSaude, setProfissionaisSaude] = useState([])
  const [horariosDisponiveis, setHorariosDisponiveis] = useState([])
  const [horarioSelecionado, setHorarioSelecionado] = useState()
  const [showExibirMaisHorarios, setShowExibirMaisHorarios] = useState(false)
  const [horariosFilter, setHorariosFilter] = useState();
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPagenumber]=useState(0)

  useEffect(() => {
    loadProfissionaisSaude();
  }, []);

  useEffect(() => {
    setPagenumber(0);
  }, [filtro]);

  const loadProfissionaisSaude = async () => {
    const unidadeAtual = await getUnidadeLogado();
    const profissionaisSaude = await profissionalSaudeStore.findByUnidadeComAgenda(unidadeAtual?.id);
    setProfissionaisSaude(profissionaisSaude)
  };

  const clearFilters = ()=>{
     atendimentoStore.horariosDisponiveis = { last: false, content: [], pageable: { pageNumber: 0 } }
      setPagenumber(0)
  }

  const handleChangeInput = (value, field) => {
    clearFilters()
    setFiltro({ ...filtro, [field]: value })
  };

  const handleCheckbox = (item, index) => {
    setHorarioSelecionado({ id: index, ...item });
  }

  const findAllHorariosDisponiveis = async (page = pageNumber) => {
    if (atendimentoStore.horariosDisponiveis.last && page > 0) return;
    atendimentoStore.horariosDisponiveis.filterVariables = filtro;
    const variables = {
      ...filtro,
      pageNumber: page
    }
    const horarios = await atendimentoStore.findAllHorariosLivresUnidade(variables);
    setHorariosDisponiveis(horarios.content);
    setShowExibirMaisHorarios(!horarios.last);
    setHorariosFilter(horarios);
  };

  const onExibirMaisResultados = () => {
    const nextPage = pageNumber + 1;
    setPagenumber(nextPage);
    findAllHorariosDisponiveis(nextPage);
  }

  return (
    <Dialog
      open={open}
      classes={{
        paper: classes.paper
      }}
      maxWidth="md"
      fullWidth
    >
      <Header
        className={classes.shadow}
        filtro={filtro}
        handleChangeInput={handleChangeInput}
        searchHorariosDisponiveis={() => {
          clearFilters();
          findAllHorariosDisponiveis(0);
        }}
        profissionaisSaude={profissionaisSaude}
        loading={loading}
      />

      <DialogContent className={classes.dialogContent}>
        <TabelaAgendamentosDisponiveis
          horariosDisponiveis={horariosDisponiveis}
          handleCheckbox={handleCheckbox}
          horarioSelecionado={horarioSelecionado}
          onExibirMaisResultados={onExibirMaisResultados}
          showExibirMaisHorarios={showExibirMaisHorarios}
        />
      </DialogContent>
      <div className={classes.dialogFooter}>
        <ButtonPrimary
          id="agd-tra-btn-cnc"
          className={classes.cancelButton}
          onClick={onCancel}
        >
          Cancelar
        </ButtonPrimary>
        <ButtonPrimary
          id="agd-tra-btn-cnf"
          className={classes.confirmButton}
          onClick={() => onConfirm(horarioSelecionado)}
        >
          Confirmar
        </ButtonPrimary>

      </div>
    </Dialog>
  )
});

const style = {
  paper: {
    maxWidth: '836px',
    height: 628,
  },

  dialogContent: {
    background: '#F2F2F4',
  },
  confirmButton: {
    borderRadius: 85,
    width: '120px',
    height: '33px',
    boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.08)",
    border: '2px solid rgba(255, 255, 255, 0.2)',
    "& > span": {
      fontSize: "14px"
    },

  },
  cancelButton: {
    borderRadius: 85,
    width: '120px',
    height: '33px',
    boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.08)",
    border: '2px solid rgba(255, 255, 255, 0.2)',
    background: '#FB7676',
    "& > span": {
      fontSize: "14px"
    },
    '&:hover': {
      background: '#C85E5E',
    }
  },
  dialogFooter: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    padding: '21px',
    backgroundColor: '#F2F2F4'
  },
  shadow: {
    boxShadow: '0px 1px 2px rgb(0 0 0 / 10%), 0px 8px 16px rgb(0 0 0 / 20%)'
  }
};

export default withStyles(style)(inject("profissionalSaudeStore", "atendimentoStore")(TransferirAgendamentos));